
import { List, Popup, Icon } from 'vant';
import { getTime, transform } from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';


export default {
  name: 'home',
  components: {
    [List.name]: List,
    [Popup.name]: Popup,
    [Icon.name]: Icon
  },
  data () {
    return {
      // 用户头像
      userHeadUrl: require('../../../assets/images/ic_head.png'),
      // 用户昵称
      userWxName: '',
      // 当前IMEI
      nowImei: '',
      // 当前ICCID
      nowIccid: '',
      // 加载状态
      loadingSimCard: true,
      // 当前SIM卡是否是小镜卡
      simIsXjCard: true,
      // 当前SIM状态
      simStateText: '',
      // 流量使用量
      flowUseMonth: 0,
      flowUseTotal: 0,
      flowUseWifi: 0,
      // 当前流量套餐到期时间
      nowMealEndTime: '',
      // 当前WIFI分享套餐到期时间
      nowWifiEndTime: '',
      // 套餐列表
      simMealList: [],
      // 显示购买记录
      showPurchase: false,
      purchaseList: [],
      // 是否是小镜卡中的硕软卡(该条件下才有购买记录)
      isSuoRuanCard: false,
      // active_time>202007 才显示usb_used_flow和hotSpot_used_flow相关的数据
      showTotalAndWifi: false,
      bRedirect: false, // 是否跳转第三方卡信息H5
    }
  },
  methods: {
    // 获取当前SIM卡信息
    getSimCardInfoFn () {
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '查询中...'
      });
      this.$axios.post('/v3/u/sim/getSimCard', { iccid: this.$store.state.nowIccid })
        .then(function (response) {
          console.log('getSimCardInfo:', response);
          // 关闭加载状态
          _this.loadingSimCard = false;
          _this.$toast.clear();
          if( !response.data || response.data.ret !== 0 ){
            return _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取套餐列表失败（' + response.data.ret + '）'
            })
          }
          let resData = response.data.data;
          _this.simIsXjCard = resData.isXJCard;
          // 判断是否是小镜卡
          if (resData && resData.thirdUrl) {
             _this.bRedirect = true;
              let url = resData.thirdUrl;
              console.log(`麦谷url: ${url}`);
              return window.location.replace(url);
            // 当前SIM卡信息
            // // 当前SIM卡信息-流量到期时间
            // _this.nowMealEndTime = getTime.getFormatDate(1, resData.stop_time);
            // // 当前SIM卡信息-WIFI到期时间
            // if ((new Date()).valueOf() < (new Date(resData.wifi_share_deadline)).valueOf()) {
            //   _this.nowWifiEndTime = getTime.getFormatDate(1, resData.wifi_share_deadline);
            // }
            // // 当前SIM卡信息-SIM卡状态
            // let simStateText = '';
            // if (resData.forbid_type === 1) {
            //   simStateText = '封停';
            // } else if (resData.status === 1) {
            //   simStateText = '已激活';
            // } else if (resData.status === 2) {
            //   simStateText = '已停用';
            // } else if (resData.status === 0) {
            //   simStateText = '未激活';
            // } else {
            //   simStateText = 'SIM卡异常';
            // }
            // _this.simStateText = simStateText;
            // // 流量使用情况 20200518 add
            // // 当月使用流量:flowUseMonth
            // let flowUseMonth = resData.total_used_flow;
            // _this.flowUseMonth = transform.flowFormat(flowUseMonth);
            // // 总使用流量:flowUseTotal,WIFI热点消耗总流量:flowUseWifi
            // // active_time>202007 才显示usb_used_flow和hotSpot_used_flow相关的数据
            // let targetTime = new Date('2020-07-01').getTime();
            // let activeTime = new Date(resData.active_time).getTime();
            // if (activeTime > targetTime) {
            //   let flowUseTotal = resData.hotSpot_used_flow + resData.usb_used_flow;
            //   let flowUseWifi = resData.hotSpot_used_flow;
            //   _this.flowUseTotal = transform.flowFormat(flowUseTotal);
            //   _this.flowUseWifi = transform.flowFormat(flowUseWifi);
            //   _this.showTotalAndWifi = true;
            // }
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 241);
        })
    },
    // 获取套餐列表
    getMealListFn () {
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '查询中...'
      });
      this.$axios.post('/sim/pkg/getBuyablePkgList', {type: 'simWifi'})
        .then(function (response) {
          // console.log(response);
          // 关闭加载状态
          _this.$toast.clear();
          if (response.data.ret === 0) {
            let resData = response.data.data;
            if (resData && resData.length > 0) {
              // 计算每天的均价
              for (let i = 0; i < resData.length; i++) {
                // 后台的价格是以分为单位
                let price = resData[i].price / 100;
                let dayNumber = 1;
                if (resData[i].valid_type === 'Y') {
                  dayNumber = parseInt(resData[i].valid_time) * 365;
                } else if (resData[i].valid_type === 'M') {
                  dayNumber = parseInt(resData[i].valid_time) * 30;
                } else if (resData[i].valid_type === 'D') {
                  dayNumber = parseInt(resData[i].valid_time);
                } else if (resData[i].valid_type === 'H') {
                  dayNumber = parseInt(resData[i].valid_time) / 24;
                }
                resData[i].pre = dayNumber ? ((price / dayNumber).toFixed(2) === '0.00' ? 0 : (price / dayNumber).toFixed(2)) : 0;
              }
              // 赋值
              _this.simMealList = resData;
            }
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取套餐列表失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 242);
        })
    },
    // 获取已购买套餐(购买记录)列表
    getPurchaseMealListFn () {
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '查询中...'
      });
      this.$axios.post('/sim/pkg/getMyPkgList', { iccid: this.$store.state.nowIccid, type: 'simWifi' })
        .then(function (response) {
          // console.log(response);
          // 关闭加载状态
          _this.$toast.clear();
          if (response.data.ret === 0) {
            let resData = response.data.data.data;
            if (resData && resData.length > 0) {
              for (let j = 0; j < resData.length; j++) {
                let effectiveText = 1;
                if (resData[j].valid_type === 'Y') {
                  effectiveText = resData[j].valid_time + '年';
                } else if (resData[j].valid_type === 'M') {
                  effectiveText = resData[j].valid_time + '个月';
                } else if (resData[j].valid_type === 'D') {
                  effectiveText = resData[j].valid_time + '天';
                } else if (resData[j].valid_type === 'H') {
                  effectiveText = resData[j].valid_time + '小时';
                }
                resData[j].buyTime = getTime.getFormatDate(2, resData[j].buy_time);
                resData[j].effectiveText = effectiveText;
                resData[j].mobileText = resData[j].mobile.substring(0, 3) + '*****' + resData[j].mobile.substring(8, 11);
              }
              _this.purchaseList = resData;
            }
            // 打开弹出层
            _this.showPurchase = true;
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '查询购买记录失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 243);
        })
    },
    // 查询购买记录
    showPurchaseFn () {
      // 获取已购买套餐
      this.getPurchaseMealListFn();
    },
    // 点击遮罩层时触发
    clickOverlay () {

    },
    closePopupFn () {
      this.showPurchase = false;
      this.clickOverlay();
    },
    // 购买套餐 确认
    buyPackagesFn (packageId, title) {
      this.$dialog.confirm({
        title: '',
        message: '请确认购买：' + title
      }).then(() => {
        // on confirm
        this.buyPackagesSubmitFn(packageId);
      }).catch(() => {
        // on cancel
      });
    },
    // 购买套餐
    buyPackagesSubmitFn (packageId) {
      if (!packageId) {
        return this.$toast('套餐ID错误');
      }
      let _this = this;
      this.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中...'
      });
      this.$axios.post('/sim/pkg/createSimPkgOrder', {
        iccid: this.$store.state.nowIccid,
        customer: this.$store.state.customer,
        payType: 'wechat', // 表示微信支付
        src: 'wx', // 表示是公众号发起的订单
        packageId: packageId, // 套餐ID
        type: 'simWifi',
      })
        .then(function (response) {
          // 关闭加载状态
          _this.$toast.clear();
          if (response.data.ret === 0) {
            let resData = response.data.data;
            try {
              if (WeixinJSBridge) {
                _this.buyPackagesPayFn(resData);
              }
            } catch (err) {
              return _this.$toast('请在微信公众号上操作！');
            }
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '购买套餐失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 244);
        })
    },
    // 购买套餐 发起支付
    buyPackagesPayFn (payData) {
      let _this = this;
      WeixinJSBridge.invoke('getBrandWCPayRequest', payData, function(res){
        if(res.err_msg === 'get_brand_wcpay_request:ok' ) {
          // success
          // 刷新当前SIM卡信息
          _this.getSimCardInfoFn();
          _this.$dialog({
            message: '恭喜您，WIFI分享套餐购买成功！'
          })
        } else {
          _this.$dialog({
            message: '很遗憾，支付失败（245）'
          })
        }
      });
    },
    // 跳转到实名认证
    toSmLinkFn () {
      window.location.href = 'https://w.url.cn/s/Atd12c0';
    }
  },
  mounted () {
    window.scrollTo(0,0);
    this.nowImei = this.$store.state.nowImei;
    this.nowIccid = this.$store.state.nowIccid;
    console.log(`this.nowImei: ${this.nowImei}, this.nowIccid: ${this.nowIccid}`);
    if( !this.nowIccid || !this.nowImei ){
      return this.$router.push('/');
    }
    // 获取当前SIM卡信息
    if (this.$store.state.nowIccid) {
      this.getSimCardInfoFn();
    }
    // 用户头像和昵称
    if (this.$store.state.wxInfo) {
      this.userHeadUrl = this.$store.state.wxInfo.headurl;
      this.userWxName = this.$store.state.wxInfo.nickname;
    }
  }
}
